import { useCallback, useEffect, useState } from "react";

const canObserve = () => typeof IntersectionObserver !== "undefined";

/**
 * Becomes true the first time the node intersects the viewport, then disconnects.
 * Starts visible when IntersectionObserver is missing (tests / old clients).
 */
export const useInViewOnce = ({
  rootMargin = "0px 0px -10% 0px",
  threshold = 0.14,
  disabled = false,
} = {}) => {
  const [node, setNode] = useState(null);
  const [inView, setInView] = useState(disabled || !canObserve());
  const ref = useCallback((next) => {
    setNode(next);
  }, []);

  useEffect(() => {
    if (disabled || inView || !node || !canObserve()) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;
        setInView(true);
        observer.disconnect();
      },
      { rootMargin, threshold }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [disabled, inView, node, rootMargin, threshold]);

  return { ref, inView };
};
